import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import request from '@/utils/request';
export function getResourcePool() {
  return _getResourcePool.apply(this, arguments);
}
function _getResourcePool() {
  _getResourcePool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request({
            url: 'cmdb/v1/pool'
          }));
      }
    }, _callee);
  }));
  return _getResourcePool.apply(this, arguments);
}
export function getBizs(_x) {
  return _getBizs.apply(this, arguments);
}
function _getBizs() {
  _getBizs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request({
            url: 'cmdb/v1/biz',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee2);
  }));
  return _getBizs.apply(this, arguments);
}
export function getMyBizList(_x2) {
  return _getMyBizList.apply(this, arguments);
}
function _getMyBizList() {
  _getMyBizList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(params) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request({
            url: 'cmdb/v2/biz_list',
            params: params
          }));
      }
    }, _callee3);
  }));
  return _getMyBizList.apply(this, arguments);
}
export function createBiz(_x3) {
  return _createBiz.apply(this, arguments);
}
function _createBiz() {
  _createBiz = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request({
            url: 'cmdb/v1/biz',
            method: 'post',
            data: data
          }));
      }
    }, _callee4);
  }));
  return _createBiz.apply(this, arguments);
}
export function updateBiz(_x4, _x5) {
  return _updateBiz.apply(this, arguments);
}
function _updateBiz() {
  _updateBiz = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id, data) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request({
            url: "cmdb/v1/biz/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee5);
  }));
  return _updateBiz.apply(this, arguments);
}
export function deleteBiz(_x6) {
  return _deleteBiz.apply(this, arguments);
}
function _deleteBiz() {
  _deleteBiz = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(id) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request({
            url: "cmdb/v1/biz/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee6);
  }));
  return _deleteBiz.apply(this, arguments);
}
export function getNodes(_x7, _x8) {
  return _getNodes.apply(this, arguments);
}
function _getNodes() {
  _getNodes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(biz_id, options) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request({
            url: 'cmdb/v1/node',
            params: _objectSpread({
              biz_id: biz_id
            }, options)
          }));
      }
    }, _callee7);
  }));
  return _getNodes.apply(this, arguments);
}
export function createNode(_x9) {
  return _createNode.apply(this, arguments);
}
function _createNode() {
  _createNode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request({
            url: 'cmdb/v1/node',
            method: 'post',
            data: data
          }));
      }
    }, _callee8);
  }));
  return _createNode.apply(this, arguments);
}
export function updateNode(_x0, _x1) {
  return _updateNode.apply(this, arguments);
}
function _updateNode() {
  _updateNode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(id, data) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request({
            url: "cmdb/v1/node/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee9);
  }));
  return _updateNode.apply(this, arguments);
}
export function deleteNode(_x10) {
  return _deleteNode.apply(this, arguments);
}
function _deleteNode() {
  _deleteNode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(id) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request({
            url: "cmdb/v1/node/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee0);
  }));
  return _deleteNode.apply(this, arguments);
}
export function getHosts(_x11, _x12) {
  return _getHosts.apply(this, arguments);
}
function _getHosts() {
  _getHosts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(biz_id, options) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request({
            url: 'cmdb/v1/hosts',
            params: _objectSpread({
              biz_id: biz_id
            }, options)
          }));
      }
    }, _callee1);
  }));
  return _getHosts.apply(this, arguments);
}
export function updateHost(_x13, _x14) {
  return _updateHost.apply(this, arguments);
}
function _updateHost() {
  _updateHost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(id, data) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request({
            url: "cmdb/v1/host/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee10);
  }));
  return _updateHost.apply(this, arguments);
}
export function getHostNodes(_x15) {
  return _getHostNodes.apply(this, arguments);
}
function _getHostNodes() {
  _getHostNodes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(id) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request({
            url: 'cmdb/v1/host_nodes',
            params: {
              id: id
            }
          }));
      }
    }, _callee11);
  }));
  return _getHostNodes.apply(this, arguments);
}
export function updateHostNodes(_x16, _x17, _x18) {
  return _updateHostNodes.apply(this, arguments);
}
function _updateHostNodes() {
  _updateHostNodes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(hosts, nodes, replace) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, request({
            url: 'cmdb/v1/host_nodes',
            method: 'put',
            data: {
              hosts: hosts,
              nodes: nodes,
              replace: replace
            }
          }));
      }
    }, _callee12);
  }));
  return _updateHostNodes.apply(this, arguments);
}
export function getDynamicGroups(_x19, _x20) {
  return _getDynamicGroups.apply(this, arguments);
}
function _getDynamicGroups() {
  _getDynamicGroups = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(biz_id, params) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request({
            url: 'cmdb/v1/dynamicgroup',
            params: _objectSpread({
              biz_id: biz_id
            }, params)
          }));
      }
    }, _callee13);
  }));
  return _getDynamicGroups.apply(this, arguments);
}
export function deleteDynamicGroup(_x21, _x22) {
  return _deleteDynamicGroup.apply(this, arguments);
}
function _deleteDynamicGroup() {
  _deleteDynamicGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(biz_id, id) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request({
            url: "cmdb/v1/dynamicgroup/".concat(id),
            method: 'delete',
            params: {
              biz_id: biz_id
            }
          }));
      }
    }, _callee14);
  }));
  return _deleteDynamicGroup.apply(this, arguments);
}
export function createDynamicGroup(_x23) {
  return _createDynamicGroup.apply(this, arguments);
}
function _createDynamicGroup() {
  _createDynamicGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, request({
            url: 'cmdb/v1/dynamicgroup',
            method: 'post',
            data: data
          }));
      }
    }, _callee15);
  }));
  return _createDynamicGroup.apply(this, arguments);
}
export function updateDynamicGroup(_x24, _x25) {
  return _updateDynamicGroup.apply(this, arguments);
}
function _updateDynamicGroup() {
  _updateDynamicGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(id, data) {
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          return _context16.a(2, request({
            url: "cmdb/v1/dynamicgroup/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee16);
  }));
  return _updateDynamicGroup.apply(this, arguments);
}
export function queryDynamicGroup(_x26, _x27) {
  return _queryDynamicGroup.apply(this, arguments);
}
function _queryDynamicGroup() {
  _queryDynamicGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(id, params) {
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          return _context17.a(2, request({
            url: "cmdb/v1/dynamicgroup/query/".concat(id),
            params: params
          }));
      }
    }, _callee17);
  }));
  return _queryDynamicGroup.apply(this, arguments);
}
export function getCmdbModelGroups(_x28) {
  return _getCmdbModelGroups.apply(this, arguments);
}
function _getCmdbModelGroups() {
  _getCmdbModelGroups = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(params) {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, request({
            url: 'cmdb/v1/cmdb_model_group',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee18);
  }));
  return _getCmdbModelGroups.apply(this, arguments);
}
export function getCmdbModelGroup(_x29) {
  return _getCmdbModelGroup.apply(this, arguments);
}
function _getCmdbModelGroup() {
  _getCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(id) {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'get'
          }));
      }
    }, _callee19);
  }));
  return _getCmdbModelGroup.apply(this, arguments);
}
export function deleteCmdbModelGroup(_x30) {
  return _deleteCmdbModelGroup.apply(this, arguments);
}
function _deleteCmdbModelGroup() {
  _deleteCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(id) {
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          return _context20.a(2, request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee20);
  }));
  return _deleteCmdbModelGroup.apply(this, arguments);
}
export function createCmdbModelGroup(_x31) {
  return _createCmdbModelGroup.apply(this, arguments);
}
function _createCmdbModelGroup() {
  _createCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(data) {
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          return _context21.a(2, request({
            url: 'cmdb/v1/cmdb_model_group',
            method: 'post',
            data: data
          }));
      }
    }, _callee21);
  }));
  return _createCmdbModelGroup.apply(this, arguments);
}
export function updateCmdbModelGroup(_x32, _x33) {
  return _updateCmdbModelGroup.apply(this, arguments);
}
function _updateCmdbModelGroup() {
  _updateCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(id, data) {
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          return _context22.a(2, request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee22);
  }));
  return _updateCmdbModelGroup.apply(this, arguments);
}
export function getCmdbModels(_x34) {
  return _getCmdbModels.apply(this, arguments);
}
function _getCmdbModels() {
  _getCmdbModels = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(params) {
    return _regenerator().w(function (_context23) {
      while (1) switch (_context23.n) {
        case 0:
          return _context23.a(2, request({
            url: 'cmdb/v1/cmdb_model',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee23);
  }));
  return _getCmdbModels.apply(this, arguments);
}
export function getCmdbModel(_x35) {
  return _getCmdbModel.apply(this, arguments);
}
function _getCmdbModel() {
  _getCmdbModel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(id) {
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          return _context24.a(2, request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'get'
          }));
      }
    }, _callee24);
  }));
  return _getCmdbModel.apply(this, arguments);
}
export function deleteCmdbModel(_x36) {
  return _deleteCmdbModel.apply(this, arguments);
}
function _deleteCmdbModel() {
  _deleteCmdbModel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(id) {
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          return _context25.a(2, request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee25);
  }));
  return _deleteCmdbModel.apply(this, arguments);
}
export function createCmdbModel(_x37) {
  return _createCmdbModel.apply(this, arguments);
}
function _createCmdbModel() {
  _createCmdbModel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(data) {
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          return _context26.a(2, request({
            url: 'cmdb/v1/cmdb_model',
            method: 'post',
            data: data
          }));
      }
    }, _callee26);
  }));
  return _createCmdbModel.apply(this, arguments);
}
export function updateCmdbModel(_x38, _x39) {
  return _updateCmdbModel.apply(this, arguments);
}
function _updateCmdbModel() {
  _updateCmdbModel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(id, data) {
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          return _context27.a(2, request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee27);
  }));
  return _updateCmdbModel.apply(this, arguments);
}
export function getCmdbModules(_x40) {
  return _getCmdbModules.apply(this, arguments);
}
function _getCmdbModules() {
  _getCmdbModules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(params) {
    return _regenerator().w(function (_context28) {
      while (1) switch (_context28.n) {
        case 0:
          return _context28.a(2, request({
            url: 'cmdb/v1/cmdb_model_module',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee28);
  }));
  return _getCmdbModules.apply(this, arguments);
}
export function getCmdbModuleOrder(_x41) {
  return _getCmdbModuleOrder.apply(this, arguments);
}
function _getCmdbModuleOrder() {
  _getCmdbModuleOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(params) {
    return _regenerator().w(function (_context29) {
      while (1) switch (_context29.n) {
        case 0:
          return _context29.a(2, request({
            url: 'cmdb/v1/cmdb_model_module/order',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee29);
  }));
  return _getCmdbModuleOrder.apply(this, arguments);
}
export function getCmdbModule(_x42) {
  return _getCmdbModule.apply(this, arguments);
}
function _getCmdbModule() {
  _getCmdbModule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(id) {
    return _regenerator().w(function (_context30) {
      while (1) switch (_context30.n) {
        case 0:
          return _context30.a(2, request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'get'
          }));
      }
    }, _callee30);
  }));
  return _getCmdbModule.apply(this, arguments);
}
export function deleteCmdbModule(_x43) {
  return _deleteCmdbModule.apply(this, arguments);
}
function _deleteCmdbModule() {
  _deleteCmdbModule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(id) {
    return _regenerator().w(function (_context31) {
      while (1) switch (_context31.n) {
        case 0:
          return _context31.a(2, request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee31);
  }));
  return _deleteCmdbModule.apply(this, arguments);
}
export function createCmdbModule(_x44) {
  return _createCmdbModule.apply(this, arguments);
}
function _createCmdbModule() {
  _createCmdbModule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(data) {
    return _regenerator().w(function (_context32) {
      while (1) switch (_context32.n) {
        case 0:
          return _context32.a(2, request({
            url: 'cmdb/v1/cmdb_model_module',
            method: 'post',
            data: data
          }));
      }
    }, _callee32);
  }));
  return _createCmdbModule.apply(this, arguments);
}
export function updateCmdbModule(_x45, _x46) {
  return _updateCmdbModule.apply(this, arguments);
}
function _updateCmdbModule() {
  _updateCmdbModule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(id, data) {
    return _regenerator().w(function (_context33) {
      while (1) switch (_context33.n) {
        case 0:
          return _context33.a(2, request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee33);
  }));
  return _updateCmdbModule.apply(this, arguments);
}
export function getCmdbFields(_x47) {
  return _getCmdbFields.apply(this, arguments);
}
function _getCmdbFields() {
  _getCmdbFields = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(params) {
    return _regenerator().w(function (_context34) {
      while (1) switch (_context34.n) {
        case 0:
          return _context34.a(2, request({
            url: 'cmdb/v1/cmdb_model_field',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee34);
  }));
  return _getCmdbFields.apply(this, arguments);
}
export function getCmdbFieldOrder(_x48) {
  return _getCmdbFieldOrder.apply(this, arguments);
}
function _getCmdbFieldOrder() {
  _getCmdbFieldOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35(params) {
    return _regenerator().w(function (_context35) {
      while (1) switch (_context35.n) {
        case 0:
          return _context35.a(2, request({
            url: 'cmdb/v1/cmdb_model_field/order',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee35);
  }));
  return _getCmdbFieldOrder.apply(this, arguments);
}
export function getCmdbField(_x49) {
  return _getCmdbField.apply(this, arguments);
}
function _getCmdbField() {
  _getCmdbField = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36(id) {
    return _regenerator().w(function (_context36) {
      while (1) switch (_context36.n) {
        case 0:
          return _context36.a(2, request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'get'
          }));
      }
    }, _callee36);
  }));
  return _getCmdbField.apply(this, arguments);
}
export function deleteCmdbField(_x50) {
  return _deleteCmdbField.apply(this, arguments);
}
function _deleteCmdbField() {
  _deleteCmdbField = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37(id) {
    return _regenerator().w(function (_context37) {
      while (1) switch (_context37.n) {
        case 0:
          return _context37.a(2, request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee37);
  }));
  return _deleteCmdbField.apply(this, arguments);
}
export function createCmdbField(_x51) {
  return _createCmdbField.apply(this, arguments);
}
function _createCmdbField() {
  _createCmdbField = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38(data) {
    return _regenerator().w(function (_context38) {
      while (1) switch (_context38.n) {
        case 0:
          return _context38.a(2, request({
            url: 'cmdb/v1/cmdb_model_field',
            method: 'post',
            data: data
          }));
      }
    }, _callee38);
  }));
  return _createCmdbField.apply(this, arguments);
}
export function updateCmdbField(_x52, _x53) {
  return _updateCmdbField.apply(this, arguments);
}
function _updateCmdbField() {
  _updateCmdbField = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee39(id, data) {
    return _regenerator().w(function (_context39) {
      while (1) switch (_context39.n) {
        case 0:
          return _context39.a(2, request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee39);
  }));
  return _updateCmdbField.apply(this, arguments);
}
export function getInstances(_x54, _x55) {
  return _getInstances.apply(this, arguments);
}
function _getInstances() {
  _getInstances = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee40(params, data) {
    return _regenerator().w(function (_context40) {
      while (1) switch (_context40.n) {
        case 0:
          return _context40.a(2, request({
            url: "cmdb/v1/instance/search",
            method: 'post',
            params: _objectSpread({}, params),
            data: data
          }));
      }
    }, _callee40);
  }));
  return _getInstances.apply(this, arguments);
}
export function getIpSelect(_x56, _x57) {
  return _getIpSelect.apply(this, arguments);
}
function _getIpSelect() {
  _getIpSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee41(bizId, data) {
    return _regenerator().w(function (_context41) {
      while (1) switch (_context41.n) {
        case 0:
          return _context41.a(2, request({
            url: "cmdb/v1/instance/".concat(bizId, "/ipselect"),
            method: 'get',
            params: {
              req_body: data
            }
          }));
      }
    }, _callee41);
  }));
  return _getIpSelect.apply(this, arguments);
}
export function deleteInstance(_x58) {
  return _deleteInstance.apply(this, arguments);
}
function _deleteInstance() {
  _deleteInstance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee42(data) {
    return _regenerator().w(function (_context42) {
      while (1) switch (_context42.n) {
        case 0:
          return _context42.a(2, request({
            url: "cmdb/v1/instance",
            method: 'delete',
            data: data
          }));
      }
    }, _callee42);
  }));
  return _deleteInstance.apply(this, arguments);
}
export function createInstance(_x59) {
  return _createInstance.apply(this, arguments);
}
function _createInstance() {
  _createInstance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee43(data) {
    return _regenerator().w(function (_context43) {
      while (1) switch (_context43.n) {
        case 0:
          return _context43.a(2, request({
            url: 'cmdb/v1/instance',
            method: 'post',
            data: data
          }));
      }
    }, _callee43);
  }));
  return _createInstance.apply(this, arguments);
}
export function updateInstance(_x60) {
  return _updateInstance.apply(this, arguments);
}
function _updateInstance() {
  _updateInstance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee44(data) {
    return _regenerator().w(function (_context44) {
      while (1) switch (_context44.n) {
        case 0:
          return _context44.a(2, request({
            url: "cmdb/v1/instance",
            method: 'put',
            data: data
          }));
      }
    }, _callee44);
  }));
  return _updateInstance.apply(this, arguments);
}
export function getCmdbTopologyTree(_x61) {
  return _getCmdbTopologyTree.apply(this, arguments);
}
function _getCmdbTopologyTree() {
  _getCmdbTopologyTree = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee45(params) {
    return _regenerator().w(function (_context45) {
      while (1) switch (_context45.n) {
        case 0:
          return _context45.a(2, request({
            url: "cmdb/v1/cmdb_topology",
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee45);
  }));
  return _getCmdbTopologyTree.apply(this, arguments);
}
export function getCmdbSystemTopologyTree(_x62) {
  return _getCmdbSystemTopologyTree.apply(this, arguments);
}
function _getCmdbSystemTopologyTree() {
  _getCmdbSystemTopologyTree = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee46(params) {
    return _regenerator().w(function (_context46) {
      while (1) switch (_context46.n) {
        case 0:
          return _context46.a(2, request({
            url: "cmdb/v1/cmdb_system_topology",
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee46);
  }));
  return _getCmdbSystemTopologyTree.apply(this, arguments);
}
export function getCmdbTopologyMap() {
  return _getCmdbTopologyMap.apply(this, arguments);
}
function _getCmdbTopologyMap() {
  _getCmdbTopologyMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee47() {
    return _regenerator().w(function (_context47) {
      while (1) switch (_context47.n) {
        case 0:
          return _context47.a(2, request({
            url: "cmdb/v1/cmdb_topology/map",
            method: 'get'
          }));
      }
    }, _callee47);
  }));
  return _getCmdbTopologyMap.apply(this, arguments);
}
export function getCmdbSystemTopologyMap() {
  return _getCmdbSystemTopologyMap.apply(this, arguments);
}
function _getCmdbSystemTopologyMap() {
  _getCmdbSystemTopologyMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee48() {
    return _regenerator().w(function (_context48) {
      while (1) switch (_context48.n) {
        case 0:
          return _context48.a(2, request({
            url: "cmdb/v1/cmdb_system_topology/map",
            method: 'get'
          }));
      }
    }, _callee48);
  }));
  return _getCmdbSystemTopologyMap.apply(this, arguments);
}
export function getCmdbTopology(_x63) {
  return _getCmdbTopology.apply(this, arguments);
}
function _getCmdbTopology() {
  _getCmdbTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee49(id) {
    return _regenerator().w(function (_context49) {
      while (1) switch (_context49.n) {
        case 0:
          return _context49.a(2, request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'get'
          }));
      }
    }, _callee49);
  }));
  return _getCmdbTopology.apply(this, arguments);
}
export function getCmdbTopologyByType(_x64, _x65) {
  return _getCmdbTopologyByType.apply(this, arguments);
}
function _getCmdbTopologyByType() {
  _getCmdbTopologyByType = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee50(biz, tid) {
    return _regenerator().w(function (_context50) {
      while (1) switch (_context50.n) {
        case 0:
          return _context50.a(2, request({
            url: "cmdb/v1/cmdb_topology/list/".concat(biz, "/").concat(tid),
            method: 'get'
          }));
      }
    }, _callee50);
  }));
  return _getCmdbTopologyByType.apply(this, arguments);
}
export function deleteCmdbTopology(_x66) {
  return _deleteCmdbTopology.apply(this, arguments);
}
function _deleteCmdbTopology() {
  _deleteCmdbTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee51(id) {
    return _regenerator().w(function (_context51) {
      while (1) switch (_context51.n) {
        case 0:
          return _context51.a(2, request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee51);
  }));
  return _deleteCmdbTopology.apply(this, arguments);
}
export function deleteCmdbSystemTopology(_x67) {
  return _deleteCmdbSystemTopology.apply(this, arguments);
}
function _deleteCmdbSystemTopology() {
  _deleteCmdbSystemTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee52(id) {
    return _regenerator().w(function (_context52) {
      while (1) switch (_context52.n) {
        case 0:
          return _context52.a(2, request({
            url: "cmdb/v1/cmdb_system_topology/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee52);
  }));
  return _deleteCmdbSystemTopology.apply(this, arguments);
}
export function createCmdbTopology(_x68) {
  return _createCmdbTopology.apply(this, arguments);
}
function _createCmdbTopology() {
  _createCmdbTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee53(data) {
    return _regenerator().w(function (_context53) {
      while (1) switch (_context53.n) {
        case 0:
          return _context53.a(2, request({
            url: 'cmdb/v1/cmdb_topology',
            method: 'post',
            data: data
          }));
      }
    }, _callee53);
  }));
  return _createCmdbTopology.apply(this, arguments);
}
export function createCmdbSystemTopology(_x69) {
  return _createCmdbSystemTopology.apply(this, arguments);
}
function _createCmdbSystemTopology() {
  _createCmdbSystemTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee54(data) {
    return _regenerator().w(function (_context54) {
      while (1) switch (_context54.n) {
        case 0:
          return _context54.a(2, request({
            url: 'cmdb/v1/cmdb_system_topology',
            method: 'post',
            data: data
          }));
      }
    }, _callee54);
  }));
  return _createCmdbSystemTopology.apply(this, arguments);
}
export function updateCmdbTopology(_x70, _x71) {
  return _updateCmdbTopology.apply(this, arguments);
}
function _updateCmdbTopology() {
  _updateCmdbTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee55(id, data) {
    return _regenerator().w(function (_context55) {
      while (1) switch (_context55.n) {
        case 0:
          return _context55.a(2, request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee55);
  }));
  return _updateCmdbTopology.apply(this, arguments);
}
export function updateCmdbSystemTopology(_x72, _x73) {
  return _updateCmdbSystemTopology.apply(this, arguments);
}
function _updateCmdbSystemTopology() {
  _updateCmdbSystemTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee56(id, data) {
    return _regenerator().w(function (_context56) {
      while (1) switch (_context56.n) {
        case 0:
          return _context56.a(2, request({
            url: "cmdb/v1/cmdb_system_topology/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee56);
  }));
  return _updateCmdbSystemTopology.apply(this, arguments);
}
export function queryCmdbTopology(_x74, _x75) {
  return _queryCmdbTopology.apply(this, arguments);
}
function _queryCmdbTopology() {
  _queryCmdbTopology = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee57(id, params) {
    return _regenerator().w(function (_context57) {
      while (1) switch (_context57.n) {
        case 0:
          return _context57.a(2, request({
            url: "cmdb/v1/cmdb_topology/query/".concat(id),
            params: params
          }));
      }
    }, _callee57);
  }));
  return _queryCmdbTopology.apply(this, arguments);
}
export function getCmdbPools(_x76) {
  return _getCmdbPools.apply(this, arguments);
}
function _getCmdbPools() {
  _getCmdbPools = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee58(params) {
    return _regenerator().w(function (_context58) {
      while (1) switch (_context58.n) {
        case 0:
          return _context58.a(2, request({
            url: 'cmdb/v1/cmdb_pool',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee58);
  }));
  return _getCmdbPools.apply(this, arguments);
}
export function getCmdbPool(_x77) {
  return _getCmdbPool.apply(this, arguments);
}
function _getCmdbPool() {
  _getCmdbPool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee59(id) {
    return _regenerator().w(function (_context59) {
      while (1) switch (_context59.n) {
        case 0:
          return _context59.a(2, request({
            url: "cmdb/v1/cmdb_pool/".concat(id),
            method: 'get'
          }));
      }
    }, _callee59);
  }));
  return _getCmdbPool.apply(this, arguments);
}
export function deleteCmdbPool(_x78) {
  return _deleteCmdbPool.apply(this, arguments);
}
function _deleteCmdbPool() {
  _deleteCmdbPool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee60(id) {
    return _regenerator().w(function (_context60) {
      while (1) switch (_context60.n) {
        case 0:
          return _context60.a(2, request({
            url: "cmdb/v1/cmdb_pool/".concat(id),
            method: 'delete'
          }));
      }
    }, _callee60);
  }));
  return _deleteCmdbPool.apply(this, arguments);
}
export function createCmdbPool(_x79) {
  return _createCmdbPool.apply(this, arguments);
}
function _createCmdbPool() {
  _createCmdbPool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee61(data) {
    return _regenerator().w(function (_context61) {
      while (1) switch (_context61.n) {
        case 0:
          return _context61.a(2, request({
            url: 'cmdb/v1/cmdb_pool',
            method: 'post',
            data: data
          }));
      }
    }, _callee61);
  }));
  return _createCmdbPool.apply(this, arguments);
}
export function updateCmdbPool(_x80, _x81) {
  return _updateCmdbPool.apply(this, arguments);
}
function _updateCmdbPool() {
  _updateCmdbPool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee62(id, data) {
    return _regenerator().w(function (_context62) {
      while (1) switch (_context62.n) {
        case 0:
          return _context62.a(2, request({
            url: "cmdb/v1/cmdb_pool/".concat(id),
            method: 'put',
            data: data
          }));
      }
    }, _callee62);
  }));
  return _updateCmdbPool.apply(this, arguments);
}
export function getCmdbModelCounts(_x82) {
  return _getCmdbModelCounts.apply(this, arguments);
}
function _getCmdbModelCounts() {
  _getCmdbModelCounts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee63(params) {
    return _regenerator().w(function (_context63) {
      while (1) switch (_context63.n) {
        case 0:
          return _context63.a(2, request({
            url: 'cmdb/v1/cmdb_model_count',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee63);
  }));
  return _getCmdbModelCounts.apply(this, arguments);
}
export function getCmdbModelCount(_x83) {
  return _getCmdbModelCount.apply(this, arguments);
}
function _getCmdbModelCount() {
  _getCmdbModelCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee64(id) {
    return _regenerator().w(function (_context64) {
      while (1) switch (_context64.n) {
        case 0:
          return _context64.a(2, request({
            url: "cmdb/v1/cmdb_model_count/".concat(id),
            method: 'get'
          }));
      }
    }, _callee64);
  }));
  return _getCmdbModelCount.apply(this, arguments);
}
export function getCmdbModelIndexs(_x84) {
  return _getCmdbModelIndexs.apply(this, arguments);
}
function _getCmdbModelIndexs() {
  _getCmdbModelIndexs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee65(params) {
    return _regenerator().w(function (_context65) {
      while (1) switch (_context65.n) {
        case 0:
          return _context65.a(2, request({
            url: 'cmdb/v1/cmdb_model_index',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee65);
  }));
  return _getCmdbModelIndexs.apply(this, arguments);
}
export function createCmdbModelIndex(_x85) {
  return _createCmdbModelIndex.apply(this, arguments);
}
function _createCmdbModelIndex() {
  _createCmdbModelIndex = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee66(data) {
    return _regenerator().w(function (_context66) {
      while (1) switch (_context66.n) {
        case 0:
          return _context66.a(2, request({
            url: 'cmdb/v1/cmdb_model_index',
            method: 'post',
            data: data
          }));
      }
    }, _callee66);
  }));
  return _createCmdbModelIndex.apply(this, arguments);
}
export function deleteCmdbModelIndex(_x86) {
  return _deleteCmdbModelIndex.apply(this, arguments);
}
function _deleteCmdbModelIndex() {
  _deleteCmdbModelIndex = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee67(data) {
    return _regenerator().w(function (_context67) {
      while (1) switch (_context67.n) {
        case 0:
          return _context67.a(2, request({
            url: 'cmdb/v1/cmdb_model_index/delete',
            method: 'post',
            data: data
          }));
      }
    }, _callee67);
  }));
  return _deleteCmdbModelIndex.apply(this, arguments);
}
export function getCmdbDeleteHistories(_x87) {
  return _getCmdbDeleteHistories.apply(this, arguments);
}
function _getCmdbDeleteHistories() {
  _getCmdbDeleteHistories = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee68(params) {
    return _regenerator().w(function (_context68) {
      while (1) switch (_context68.n) {
        case 0:
          return _context68.a(2, request({
            url: 'cmdb/v1/cmdb_delete_history',
            method: 'get',
            params: _objectSpread({}, params)
          }));
      }
    }, _callee68);
  }));
  return _getCmdbDeleteHistories.apply(this, arguments);
}